import { COMPANION_ANIMAL_INFO  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(COMPANION_ANIMAL_INFO)
